import { render, staticRenderFns } from "./stationV3.vue?vue&type=template&id=a58d5512&scoped=true"
import script from "./stationV3.vue?vue&type=script&lang=js"
export * from "./stationV3.vue?vue&type=script&lang=js"
import style0 from "./stationV3.vue?vue&type=style&index=0&id=a58d5512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58d5512",
  null
  
)

export default component.exports